import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
import { Media } from '../../theme/Media';
import Tooltip from '../../V2/Feedback/Tooltip';
import { useTableContext } from './context';
import { Wrapper as TdWrapper, Container as TdContainer } from './Td';
export const Wrapper = styled.tr `
  position: relative;
  cursor: ${({ onClick }) => !!onClick && 'pointer'};
  color: ${({ isInactive, theme }) => isInactive && theme.colors.grey70_1};
  ${({ isUnCollapsed, theme }) => isUnCollapsed &&
    css `
      ${TdWrapper} {
        background: ${theme.colors.grey30_1};
      }
    `}
  ${({ isActive, theme }) => isActive &&
    css `
      ${TdWrapper} {
        background: ${theme.colors.grey30_1};
      }
    `}
  ${({ bgColor, isActive }) => !!bgColor &&
    !isActive &&
    css `
      ${TdWrapper} {
        background: ${bgColor};
      }
    `}
  ${({ enabled, theme }) => enabled &&
    css `
      ${TdWrapper} {
        &:first-child {
          ${TdContainer} {
            position: relative;
            &:before {
              content: '';
              display: block;
              height: 100%;
              width: 2px;
              position: absolute;
              left: 0;
              top: 0;
              background: ${theme.colors.main};
            }
          }
        }
      }
    `}
  @media ${({ isCollapsedNav }) => (isCollapsedNav ? Media.lgMin : Media.xlgMin)} {
    ${({ hover, theme }) => hover &&
    css `
        &:hover ${TdWrapper} {
          background-color: ${theme.colors.grey05_1};
        }
      `}

    ${({ isCollapsible, theme }) => isCollapsible &&
    css `
        &:hover ${TdWrapper} {
          background-color: ${theme.colors.grey30_1};
        }
      `}
  }
  @media ${({ isCollapsedNav }) => (isCollapsedNav ? Media.mdMax : Media.lgMax)} {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 2px;
  }

  @media ${Media.mdMin} and ${({ isCollapsedNav }) => (isCollapsedNav ? Media.mdMax : Media.lgMax)} {
    width: calc(50% - 2px);
    &:nth-child(even) {
      margin-left: 4px;
    }
  }
  @media ${Media.smMax} {
    width: 100%;
  }
`;
const Tr = React.forwardRef(function Tr({ onClick, children, className, rowIndex, enabled, bgColor, dataTestId, onMouseLeave, isCollapsible, isUnCollapsed, tooltip, hover, isInactive, }, ref) {
    const { activeRow, isCollapsedNav } = useTableContext();
    return (_jsx(Tooltip, { tooltip: tooltip, placement: 'bottom', className: className, dataTestId: dataTestId, ContainerComponent: Wrapper, containerComponentProps: {
            key: rowIndex,
            enabled,
            isActive: activeRow !== undefined && rowIndex !== undefined && rowIndex === activeRow,
            isInactive,
            bgColor,
            onClick,
            ref,
            onMouseLeave,
            isCollapsible,
            isUnCollapsed,
            isCollapsedNav,
            hover,
        }, children: children }));
});
export default React.memo(Tr);
